export enum ConceptInvoicingEnums {
    alquiler = 1,
    transporte = 2,
    faltantes_reposiciones = 3,
    reparaciones = 4,
    accesorios = 5,
    limpieza = 6,
    administracion = 7,
    imprevistos = 8,
    utilidad = 9,
}

export enum ConceptInvoicingTypeEnums {
    venta = 1,
    compra = 2,
}

export enum ConceptInvoicingPriceOfEnums {
    ninguno = 1,
    reposicion = 2,
    venta = 3,
    alquiler = 4,
}

export enum PurchaseConceptEnums {
    compras = 1,
    servicios = 2,
}